/**
 * Sitewide snappy navigation: hover/touch prefetch + InstantClick helpers.
 */
(function (window, document) {
  'use strict';

  var prefetched = {};
  var PREFETCH_LIMIT = 24;
  var count = 0;

  function sameOrigin(href) {
    if (!href || href.charAt(0) === '#') return false;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return false;
    if (href.indexOf('javascript:') === 0) return false;
    try {
      var u = new URL(href, window.location.href);
      return u.origin === window.location.origin;
    } catch (e) {
      return href.charAt(0) === '/';
    }
  }

  function prefetch(href) {
    if (!href || !sameOrigin(href) || prefetched[href] || count >= PREFETCH_LIMIT) {
      return;
    }
    // Skip cart/checkout/account and asset-ish URLs
    if (/\/(cart|checkouts|account|apps)\b/i.test(href)) return;
    if (/\.(js|css|json|svg|png|jpe?g|webp|gif)(\?|$)/i.test(href)) return;

    prefetched[href] = true;
    count++;

    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function hrefFromEvent(ev) {
    var t = ev.target;
    if (!t) return '';
    var a = t.closest ? t.closest('a[href]') : null;
    if (!a) return '';
    if (a.hasAttribute('data-no-instant') || a.getAttribute('target') === '_blank') {
      return '';
    }
    return a.href || '';
  }

  function onIntent(ev) {
    var href = hrefFromEvent(ev);
    if (href) prefetch(href);
  }

  function reinitTheme() {
    try {
      if (window.wmnEngagement && typeof window.wmnEngagement.init === 'function') {
        window.wmnEngagement.init();
      }
    } catch (e1) {}
    try {
      if (window.wmnMotion && typeof window.wmnMotion.init === 'function') {
        window.wmnMotion.init();
      }
    } catch (e2) {}
    try {
      if (window.lazySizes && typeof window.lazySizes.autoSizer === 'object') {
        window.lazySizes.autoSizer.checkElems();
      }
      if (window.lazySizes && typeof window.lazySizes.loader === 'object') {
        window.lazySizes.loader.checkElems();
      }
    } catch (e3) {}
  }

  function boot() {
    document.addEventListener('pointerover', onIntent, { capture: true, passive: true });
    document.addEventListener('touchstart', onIntent, { capture: true, passive: true });
    document.addEventListener('focusin', onIntent, true);

    if (window.InstantClick) {
      try {
        InstantClick.on('change', function () {
          // Small yield so DOM is swapped, then re-arm observers / lazysizes.
          setTimeout(reinitTheme, 0);
        });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.wmnPerf = { prefetch: prefetch, reinit: reinitTheme };
})(window, document);
